import { render } from "./CoinLogsList.vue?vue&type=template&id=46d1ad92"
import script from "./CoinLogsList.vue?vue&type=script&lang=js"
export * from "./CoinLogsList.vue?vue&type=script&lang=js"

import "./CoinLogsList.vue?vue&type=style&index=0&id=46d1ad92&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__